export class EmployerRegistrationRequest {
  id: number | 0;
  adminName: string;
  adminWebsite: string;
  employerName: string;
  einNumber: string;
  employerWebsite: string;
  employerLine: string;
  employerLine2: string;
  employerCity: string;
  employerState: string;
  employerZipCode: string;
  employerFirstName: string;
  employerLastName: string;
  employerTitle: string;
  employerPhone: string;
  employerEmail: string;
  isActive: boolean | false;
  isApproved: boolean | false;
  approvedBy: number | 0;
  createdOn: string | null;
  approvedOn: string;

}
